module.exports = __webpack_public_path__ + "assets/img/elem4-ability2.ceb97c94.gif";